const focusableElementsSelector =
  'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'

export const useFocusTrap = () => {
  const trapRef = customRef((track, trigger) => {
    let $trapEl = null as any
    return {
      get() {
        track()
        return $trapEl
      },
      set(value) {
        $trapEl = value
        value ? initFocusTrap() : clearFocusTrap()
        trigger()
      },
    }
  })
  onMounted(() => {
    if (trapRef.value) initFocusTrap()
  })

  onBeforeUnmount(() => {
    clearFocusTrap()
  })

  let previouslyFocusedElement: HTMLElement
  let focusableElements = []
  let firstFocusable: HTMLElement
  let lastFocusable: HTMLElement

  function keyHandler(e: KeyboardEvent) {
    const isTabPressed = e.key === 'Tab'

    if (!isTabPressed) return

    if (e.shiftKey) {
      if (document.activeElement === firstFocusable) {
        lastFocusable.focus()
        e.preventDefault()
      }
    } else if (document.activeElement === lastFocusable) {
      firstFocusable.focus()
      e.preventDefault()
    }
  }

  function initFocusTrap() {
    // Bail out if there is no value
    if (!trapRef.value) return
    if (import.meta.browser) {
      previouslyFocusedElement = document.activeElement as HTMLElement
    }

    focusableElements = trapRef.value.querySelectorAll(
      focusableElementsSelector,
    )
    firstFocusable = focusableElements[0]
    lastFocusable = focusableElements[focusableElements.length - 1]
    document.addEventListener('keydown', keyHandler)
    trapRef.value.focus()
  }

  function clearFocusTrap() {
    document.removeEventListener('keydown', keyHandler)

    if (!previouslyFocusedElement) return
    previouslyFocusedElement.focus()
    previouslyFocusedElement.blur()
  }

  return {
    trapRef,
    initFocusTrap,
    clearFocusTrap,
  }
}
